import styled from 'styled-components';
import { Plate } from './plate';

export const InlinePlate = styled(Plate)`
  display: inline-flex;
  flex-direction: column;
`;
